import { useBreadcrumbs as useBaseBreadcrumbs } from "../hooks/useBreadcrumbs";
import { BreadcrumbItem } from "../models/breadcrumbs";

import type { ComponentType } from "react";

export function withBreadcrumbs<Props extends object>(
  Component: ComponentType<Props>,
  useBreadcrumbs: () => BreadcrumbItem[]
) {
  return function (props: Props) {
    const breadcrumbs = useBreadcrumbs();

    useBaseBreadcrumbs({ breadcrumbs });

    return <Component {...props} />;
  };
}
